import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import cogoToast from "cogo-toast";
import { BACKEND_URL } from "../../../constants";
import Input from "components/Input/Input";
import PublitioAPI from 'publitio_js_sdk'
import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import 'moment/locale/pl';
import ClipLoader from "react-spinners/ClipLoader";
import "react-datetime/css/react-datetime.css";
import Layout from "../../(articles)/layout";
import SectionNewspapperPreviewOne from "components/Sections/SectionNewspapperPreviewOne"

const PageAddNewspappers = () => {
  const publitio = new PublitioAPI('m7RBc51bBSJtDLyfn5ox', 'D7e4hWupPLHs0wqpXQDNQy2kJ6vVQZWZ')
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [isPreview, setIsPreview] = useState(false)
  const {
    register,
    getValues,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      title: "",
      title_home: "",
      first_description:"",
      second_description:"",
      image: "",
      pdf:"",
      isVisible: undefined
    },
  });

  const title = watch("title");
const titleHome = watch("title_home");
const firstDescription = watch("first_description");
const secondDescription = watch("second_description");
const image = watch("image");
const pdf = watch("pdf");
const isVisible = watch("isVisible");

const previewImage = image?.[0]
  ? URL.createObjectURL(image[0])
  : null;

const previewNewspapper = {
  title: watch("title"),
  title_home: watch("title_home"),
  first_description: watch("first_description"),
  second_description: watch("second_description"),
  image: previewImage,
  pdf: null,
  isVisible: 1,
};

 const isPreviewDisabled =
  !title ||
  !titleHome ||
  !firstDescription ||
  !secondDescription ||
  !image?.[0] ||
  !pdf?.[0] ||
  (isVisible !== 0 && isVisible !== 1);

  const addNewspappers = async () => {
  
  if (loading) return;

  setLoading(true);

  try {
    const data = getValues();

    const photo = await publitio.uploadFile(data.image[0], "file");
    const pdf = await publitio.uploadFile(data.pdf[0], "file");

    const response = await fetch(`${BACKEND_URL}/add-newspappers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        title: data.title,
        title_home: data.title_home,
        first_description: data.first_description,
        second_description: data.second_description,
        image: photo.url_preview ? photo.url_preview : null,
        pdf: pdf.url_preview ? pdf.url_preview : null,
        isVisible: data.isVisible
      }),
    });

    const result = await response.json();

    if (result.statusCode === 200) {
      cogoToast.success("Gazeta została dodana");
      navigate("/get-all-newspappers");
    } else {
      cogoToast.error("Wystąpił jakiś błąd");
    }
  } catch (error) {
    console.error("error:", error);
    cogoToast.error("Wystąpił błąd podczas dodawania gazety");
  } finally {
    setLoading(false);
  }
};
  return (
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20 ">
        <Heading2>Dodaj Gazetę</Heading2>
      </header>

      <div className="max-w-md mx-auto space-y-6">
        {/* FORM */}
       <form onSubmit={handleSubmit(addNewspappers)}>
          <label className="block">
            <Input
             {...register("title", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj tytuł gazety na podstronie Gazety"
              className="mt-1 mb-1"
            />
          </label>
          <label className="block">
            <Input
             {...register("title_home", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj tytuł gazety na stronie głównej"
              className="mt-1 mb-1"
            />
          </label>
          <label className="block">
            <textarea
             {...register("first_description", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj pierwszy opis do gazety na stronie głównej"
              className="mt-1 mb-1 block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200/50 bg-white dark:border-neutral-500 dark:focus:ring-primary-500/30 dark:bg-neutral-900"
            />
          </label>
           <label className="block">
            <textarea
             {...register("second_description", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj drugi opis do gazety na stronie głównej"
              className="mt-1 mb-1 block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200/50 bg-white dark:border-neutral-500 dark:focus:ring-primary-500/30 dark:bg-neutral-900"
            />
          </label>
          <label className="block">
           <select
            {...register("isVisible", { valueAsNumber: true })}
            style={{ borderRadius: "0px" }}
          >
            <option value="">Wybierz opcję widoczności</option>
            <option value="0">Ukryj</option>
            <option value="1">Pokaż</option>
          </select>
          </label>
          <label style={{marginTop:"10px"}} className="block">Dodaj okładkę do gazety
            <Input
              {...register("image", {
                required: "Okładka jest wymagana",
              })}
              type="file"
              className="mt-1"
            />
          </label>
           <label style={{marginBottom:"10px", marginTop:"10px"}} className="block">Dodaj gazetę pdf
           <Input
              {...register("pdf", {
                required: "Plik PDF jest wymagany",
              })}
              type="file"
              className="mt-1"
            />
          </label>
          <ButtonPrimary type="submit">
            Dodaj Gazetę
          </ButtonPrimary>
        </form>
        {loading === true && 
        <div style={{marginTop:'40px'}}>
          <p style={{marginBottom:'20px'}}>Uwaga dodawanie gazety może chwile potrwać zależności od wielkości wysłanego pliku pdf.</p>
          <ClipLoader color="black" size={50} aria-label="Loading Spinner" data-testid="loader"/>
          </div>}
          <button
  type="button"
  disabled={isPreviewDisabled}
  onClick={() => setIsPreview(true)}
>
  Pokaz preview gazety
</button>

{isPreview && (
  <SectionNewspapperPreviewOne
    heading="W najnowszym numerze"
    posts={[previewNewspapper]}
    isPreview={true}
  />
)}
      </div>
    </Layout>
  );
};

export default PageAddNewspappers;